var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAddPhoto = function SvgAddPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18,
    fill: "#F0F0F0",
    stroke: "#05050F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.252 13.077.043.04h1.318A2.373 2.373 0 0 1 27 15.502v8.392a2.385 2.385 0 0 1-2.387 2.387h-12.1a2.385 2.385 0 0 1-2.387-2.387v-8.391a2.385 2.385 0 0 1 2.387-2.388h1.318l.043-.04 2.018-1.86a.35.35 0 0 1 .231-.09h4.88c.113 0 .163.027.209.07h.001v.001l2.038 1.88Zm-1.937-1.99v-.001.001Zm-6.265-.83-.004.004-1.713 1.58h-.82a3.66 3.66 0 0 0-3.663 3.663v8.391a3.66 3.66 0 0 0 3.663 3.663h12.1a3.66 3.66 0 0 0 3.663-3.663v-8.391a3.648 3.648 0 0 0-3.663-3.663h-.82l-1.713-1.58a1.537 1.537 0 0 0-1.078-.411h-4.879c-.41 0-.775.152-1.073.407Z",
    fill: "#05050F",
    stroke: "#05050F",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.992 22.435v-7.557h1.283v7.557h-1.282Zm-3.137-3.137v-1.283h7.557v1.283h-7.556Z",
    fill: "#05050F"
  })));
};

export default SvgAddPhoto;